import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.6_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_react-d_d7dc0aecccb497d204a846cc63545821/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/actions/Button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/components/InlineVideo.tsx");
